import Contact from "./Contact";
import Introduction from "./Introduction";
import Guide from "./Guide";
import Price from "./Price";
import Navi from "../components/Navi";
import DownLoad from "./Download";

function Home() {
  return (
    <>
      <Navi />
      <Introduction />
      <Guide />
      <DownLoad />
      <Price />
      <Contact />
    </>
  );
}

export default Home;
